/**
 * The field names and the refusal message the sign-in bot check shares between the form and the
 * BFF. Pure constants with no imports, so the frontend reads this file through `@shared` without
 * pulling the server's logger into the bundle (the same arrangement as guideHtmlRules).
 */

/** Hidden from people; simple bots fill every field they find. */
export const HONEYPOT_FIELD = 'company_website';
/** The token the Turnstile widget produced. */
export const TOKEN_FIELD = 'turnstileToken';
/**
 * Sent only with a token-less submit: Cloudflare's error code in the browser, or `no-token-yet`.
 * Logged, never trusted; a bot can write anything here and is refused for the missing token anyway.
 */
export const CLIENT_ERROR_FIELD = 'turnstileClientError';
/** What the person is shown on a refusal. Specific on purpose: a generic error reads as a bug. */
export const BOT_CHECK_MESSAGE = 'We could not confirm you are a person. Please try again.';
